import { useState } from "react";
import imgevent from "../../assets/images/imgevent.webp";
import { MdChevronRight } from "react-icons/md";
import { Divider } from "@mui/material";
import Paginations from "./Paginitons";
import Tabpc from "./Tabpc";

export default function TimeBody() {
  const [activeTab, setActiveTab] = useState("latest");

  return (
    <div className="w-full">
      <div className="container mx-auto p-3 block md:hidden lg:hidden">
        <div className="h-[118px] rounded-[16px] w-full bg-white border border-solid border-gray-200">
          {/* Tab header */}
          <div className="w-full h-[59px] bg-[#27C6FF] flex items-center justify-center rounded-t-xl">
            <button
              onClick={() => setActiveTab("latest")}
              className={`text-white px-4 py-2 ${
                activeTab === "latest" ? "font-bold" : ""
              }`}
            >
              Tin mới nhất
            </button>
          </div>

          <div className="flex items-center justify-center w-full">
            <button
              onClick={() => setActiveTab("events")}
              className={`w-1/2 flex items-center justify-center py-3 ${
                activeTab === "events" ? "font-bold" : ""
              }`}
            >
              Sự kiện
            </button>

            {/* Vertical divider */}
            <div className="h-14 w-[1px] bg-gray-300"></div>

            <button
              onClick={() => setActiveTab("news")}
              className={`w-1/2 flex items-center justify-center py-3 ${
                activeTab === "news" ? "font-bold" : ""
              }`}
            >
              Tin tức
            </button>
          </div>
        </div>

        {/* Tab content */}
        <div className="mt-4">
          {activeTab === "latest" && (
            <div className="w-full grid grid-cols-1 gap-4 ">
              <div className=" shadow-custom max-w-full relative rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
                <div>
                  <img
                    src={imgevent}
                    alt="img"
                    className="w-full h-auto rounded-t-[20px] "
                  />
                </div>

                <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px]  ">
                  <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] relative bottom-[40px] z-10 flex items-center justify-center">
                    <p className="text-[16px] font-normal text-white">
                      Tin tức
                    </p>
                  </div>
                  <p className="text-[24px] font-semibold text-[#0C5393]">
                    Lorem ipsum dolor sit amet.
                  </p>
                  <p className="text-[16px] font-normal text-[#333333]">
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                  </p>
                  <a href="new-detail">
                    <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB]">
                      <p>Xem chi tiết</p>
                      <MdChevronRight />
                    </div>
                  </a>
                </div>
              </div>
              <div className=" shadow-custom max-w-full rounded-[20px] relative h-auto object-cover border border-solid border-[#E2E2E2]">
                <div>
                  <img
                    src={imgevent}
                    alt="img"
                    className="w-full h-auto rounded-t-[20px] "
                  />
                </div>

                <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                  <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] relative bottom-[40px] z-10 flex items-center justify-center">
                    <p className="text-[16px] font-normal text-white">
                      Tin tức
                    </p>
                  </div>
                  <p className="text-[24px] font-semibold text-[#0C5393]">
                    Lorem ipsum dolor sit amet.
                  </p>
                  <p className="text-[16px] font-normal text-[#333333]">
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                  </p>
                  <a href="new-detail">
                    <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB]">
                      <p>Xem chi tiết</p>
                      <MdChevronRight />
                    </div>
                  </a>
                </div>
              </div>
              <div className=" shadow-custom max-w-full rounded-[20px] relative h-auto object-cover border border-solid border-[#E2E2E2]">
                <div>
                  <img
                    src={imgevent}
                    alt="img"
                    className="w-full h-auto rounded-t-[20px] "
                  />
                </div>

                <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                  <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] relative bottom-[40px] z-10 flex items-center justify-center">
                    <p className="text-[16px] font-normal text-white">
                      Tin tức
                    </p>
                  </div>
                  <p className="text-[24px] font-semibold text-[#0C5393]">
                    Lorem ipsum dolor sit amet.
                  </p>
                  <p className="text-[16px] font-normal text-[#333333]">
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                  </p>
                  <a href="new-detail">
                    <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB]">
                      <p>Xem chi tiết</p>
                      <MdChevronRight />
                    </div>
                  </a>
                </div>
              </div>
              <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover relative border border-solid border-[#E2E2E2]">
                <div>
                  <img
                    src={imgevent}
                    alt="img"
                    className="w-full h-auto rounded-t-[20px] "
                  />
                </div>

                <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                  <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] relative bottom-[40px] z-10 flex items-center justify-center">
                    <p className="text-[16px] font-normal text-white">
                      Tin tức
                    </p>
                  </div>
                  <p className="text-[24px] font-semibold text-[#0C5393]">
                    Lorem ipsum dolor sit amet.
                  </p>
                  <p className="text-[16px] font-normal text-[#333333]">
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                  </p>
                  <a href="new-detail">
                    <div className="flex items-center gap-2 text-[16px] font-normal  text-[#1C9BDB]">
                      <p>Xem chi tiết</p>
                      <MdChevronRight />
                    </div>
                  </a>
                </div>
              </div>
              <div>
                <Divider />
              </div>
              <Paginations />
            </div>
          )}
          {activeTab === "events" && <p>Nội dung cho Sự kiện</p>}
          {activeTab === "news" && <p>Nội dung cho Tin tức</p>}
        </div>
      </div>
      <div className="container mx-auto p-3 hidden md:block lg:block">
        <Tabpc />
      </div>
    </div>
  );
}
